<div class="favorites-listing" *ngIf="userInfo">
  <div class="favorites-listing__header">
    <h1 class="favorites-listing__header-text">Favorite Airports</h1>
    <div class="favorites-listing__header-actions">
      <button *ngIf="favorites && favorites.length" type="button" (click)="downloadProcs()" mat-button
              class="aopa-mat-btn aopa-mat-btn--outlined"
              matTooltip="Download terminal procedures for your favorite airports.">
        Download Procedures
      </button>
    </div>
  </div>
  <app-state-view [promise]="favoritesPromise">
    <loading-state>
      <div class="favorites-listing__loading">
        <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
      </div>
    </loading-state>
    <empty-state>
      <div class="favorites-listing__placeholder">
        <mat-icon class="favorites-listing__placeholder-icon">info</mat-icon>
        <div class="favorites-listing__placeholder-message">No airports are currently marked as home or favorite.</div>
      </div>
    </empty-state>
    <error-state>
      <div class="favorites-listing__placeholder favorites-listing__placeholder--error">
        <mat-icon class="favorites-listing__placeholder-icon">warning</mat-icon>
        <div class="favorites-listing__placeholder-message">
          {{ errorMessage || 'An error occurred loading your favorite airports. Please try again later.' }}
        </div>
      </div>
    </error-state>
    <content-state>
      <div class="favorites-listing__container" *ngIf="favorites && favorites.length > 0; else placeholder">
        <app-airport-summary-card #airportEl *ngFor="let airport of favorites"
                                  class="favorites-listing__card" [airport]="airport"
                                  [active]="airport === activeAirport" [interactive]="true">
        </app-airport-summary-card>

        <!-- Placeholder cards to fix layout when the number of airports is not divisible by 3 -->
        <div *ngIf="favorites.length % 3 !== 0" class="favorites-listing__card"></div>
        <div *ngIf="(favorites.length + 1) % 3 !== 0" class="favorites-listing__card"></div>
      </div>
    </content-state>
  </app-state-view>
  <ng-template #placeholder>
    <div class="favorites-listing__placeholder" *ngIf="authenticated">
      <mat-icon class="favorites-listing__placeholder-icon">info</mat-icon>
      <div class="favorites-listing__placeholder-message">No home or favorite airports found.</div>
    </div>
  </ng-template>
</div>
